export default "__VITE_ASSET__883f86df__"